// extracted by mini-css-extract-plugin
export var container = "_10a-0";